import * as APIRoutes from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export class InstagramController extends AuthenticatedController {
  static async activateIG(fbPageId: number, shallow: boolean) {
    return super.post(APIRoutes.ACTIVATE_INSTAGRAM(fbPageId, shallow));
  }
  static async deactivateIG(fbPageId: number) {
    return super.post(APIRoutes.DEACTIVATE_INSTAGRAM(fbPageId));
  }
  static async getIGAccounts(fbPageId: number) {
    return super.get(APIRoutes.INSTAGRAM_ACCOUNTS(fbPageId));
  }
  static async getIGStory(mid: string, fbPageId: number) {
    return super.get(APIRoutes.INSTAGRAM_STORIES(mid, fbPageId));
  }
  static async getRemoteIGMessage(mid: string, fbPageId: number) {
    return super.get(APIRoutes.INSTAGRAM_REMOTE_MESSAGE(mid, fbPageId));
  }
  static async getLocalIGMessage(
    mid: string,
    fbPageId: number,
    remoteContactId: string,
  ) {
    return super.get(
      APIRoutes.INSTAGRAM_LOCAL_MESSAGE(mid, fbPageId, remoteContactId),
    );
  }
  static async getIGListMedia(
    fbPageId: number,
    cursor: string,
    cursorValue: string,
  ) {
    return super.get(
      APIRoutes.INSTAGRAM_LIST_MEDIA(fbPageId, cursor, cursorValue),
    );
  }
  static async getIGMedia(fbPageId: number, mediaId: string) {
    return super.get(APIRoutes.INSTAGRAM_MEDIA(fbPageId, mediaId));
  }
}
